import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Spinner from "../../components/spinner";
import { axiosApi } from "../../../services/axios_api";
import PaginatorComponent from "../../components/paginator";
import useDebounce from "../../components/hooks/useDebounce";
import { toast } from "react-toastify";
import moment from "moment";
import { Dialog } from "primereact/dialog";
import Dots from "../../../../assets/assests/detail.png";
import { exportToExcel, renderTextWithTooltip } from "../../components/helper";
import { Tag } from "primereact/tag";

import Details from "./details_cash";
import { Button } from "primereact/button";
export default function CashMonitor({
  globalFilter,
  exportCSV,
  fromDate,
  toDate,
}) {
  const [loading, setLoading] = useState(false);
  const [filteredList, setFilteredList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);

  const [rowselect, setRowselect] = useState(null);
  const [showdetail, setShowdetail] = useState(false);
  const debouncedSearch = useDebounce(globalFilter, 500);

  const getCashMonitorData = async (pageNumber = 1, pageSize = rows) => {
    setLoading(true);
    try {
      const response = await axiosApi.get(
        `/Portal/kiosks/monitor/cash/get-all-paginated`,
        {
          params: {
            pageNumber,
            pageSize,
            searchTerm: debouncedSearch || "",
            fromDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : null,
            toDate: toDate ? moment(toDate).format("YYYY-MM-DD") : null,
          },
        }
      );
      setFilteredList(response.data.body);
      setTotalRecords(response.data.totalRecords);
    } catch (error) {
      toast.error("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };
 

  const handlePageChange = (event) => {
    const { first, rows } = event;
    setFirst(first);
    setRows(rows);
    const pageNumber = first / rows + 1;
    getCashMonitorData(pageNumber, rows);
  };

  useEffect(() => {
    getCashMonitorData();
  }, [debouncedSearch, fromDate, toDate]);

  const actionTemplate = (rowData) => {
    return (
      <div className="action-buttons">
       
        <Button className="p-button-edit p-0 mr-3" onClick={() => showDetails(rowData)}>
          <img src={Dots} alt="Details" />
        </Button>

      </div>
    );
  };

  const columnsData = [
    // {
    //   field: "kioskId",
    //   header: "Kiosk ID",
    //   body: (rowData) => rowData.kioskId || "--",
    //   frozen: true,
    // },
    {
      field: "kioskName",
      header: "Kiosk Name",
      frozen: true,
      body: (rowData) => renderTextWithTooltip(rowData, "kioskName", "bottom"),
    },
    {
      field: "totalAmount",
      header: "Total Amount(PKR)",
      body: (rowData) => rowData.totalAmount || "--",
    },
    {
      field: "warningThresholdIndicator",
      header: "Warn Threshold (PKR)",
      // body: (rowData) => rowData.Mobile || "--",
    },
    {
      field: "alertThresholdIndicator",
      header: "Alert Threshold (PKR)",
      body: (rowData) => rowData.alertThresholdIndicator || "--",
    },
    {
      field: "cashDenominations",
      header: "Cash Denomination(PKR)",
      body: (rowData) => rowData.cashDenominations || "--",
    },
    {
      field: "status",
      header: "Status",
      body: (rowData) => (
        <Tag
          className={
            rowData.status === "Normal"
              ? "custom-success-tag"
              : "custom-danger-tag"
          }
          value={rowData.status ?? "--"}
        />
      ),
    },
    // {
    //   field: "createdDate",
    //   header: "created Date",
    //   body: (rowData) =>
    //     rowData.createdDate
    //       ? moment(rowData.createdDate).format("YYYY-MM-DD HH:mm:ss")
    //       : "--",
    // },
    {
      field: "lastUpdated",
      header: "Last Update",
      body: (rowData) =>
        rowData.lastUpdated
          ? moment(rowData.lastUpdated).format("YYYY-MM-DD HH:mm:ss")
          : "--",
    },
    {
      header: "Action",
      body: actionTemplate,
    },
  ];
  
  const exportCSVHandler = async () => {
    setLoading(true);
    try {
      const response = await axiosApi.get(
        `/Portal/kiosks/monitor/cash/get-all`
      );
      exportToExcel(response.data.body, columnsData, "CashMonitorData");
    } catch (error) {
      toast.error("Failed to export data.");
      console.error("Export Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (exportCSV) {
      exportCSV.current = exportCSVHandler;
    }
  }, []);
  const showDetails = (rowData) => {
    setRowselect(rowData);
    setShowdetail(true);
  }
  return (
    <>
     <Dialog
        visible={showdetail}
        onHide={() => setShowdetail(false)}
        header="Cash Monitor Details"
       className="dialog-size"
      >
        <Details
                  rowData={ rowselect } />
      </Dialog>
      {loading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}

      <div className="card card-container">
        <DataTable
          emptyMessage="No record found."
          value={filteredList}
          className="custom-data-table"
          scrollable
          globalFilter={globalFilter}
        >
          {columnsData.map((data, index) => (
            <Column
              key={index}
              field={data.field}
              header={data.header}
              body={data.body}
              frozen={data.frozen}
            />
          ))}
        </DataTable>
        {totalRecords > 0 && (
          <PaginatorComponent
            first={first}
            rows={rows}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </>
  );
}
